import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterDrawerComponent } from './footer-drawer.component';
import { FooterDrawerService } from './footer-drawer.service';

@NgModule({
    declarations: [FooterDrawerComponent],
    exports: [FooterDrawerComponent],
    imports: [CommonModule],
    providers: [FooterDrawerService]
})
export class FooterDrawerModule {}
